import React from 'react';

const Loader = () => (
  <div className='loader is-flex is-justify-content-center'>
    <div className='spinner-container'>
      <div className='spinner'></div>
    </div>
  </div>
);

export default Loader;
